
const req = require.context('!svg-sprite-loader?{"symbolId":"rt-portal-[name]"}!./svgs', false, /.svg$/);

const requireAllSvgs =  requireContext => requireContext.keys().map(requireContext);

requireAllSvgs(req);


// WEBPACK FOOTER //
// ./src/assets/icons/index.js